module.exports = __webpack_public_path__ + "static/img/minhang_logo.20b6896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/minhang_logo.png
// module id = TOgg
// module chunks = 1